// Module
var code = `<form-section-field field-title="'Enabled'">
  <select required
          boolean-options
          ng-model="\$ctrl.config.enabled">
  </select>
</form-section-field>
<form-section-field field-title="'Recipients'">
  <selectize ng-required="\$ctrl.config.enabled"
             ng-model="\$ctrl.config.recipients"
             options="\$ctrl.recipientsOptions"
             config="\$ctrl.recipientsConfig">
  </selectize>
</form-section-field>
<form-section-field field-title="'Bcc'">
  <selectize ng-model="\$ctrl.config.bcc"
             config="\$ctrl.bccConfig"
             options="\$ctrl.bccOptions">
  </selectize>
</form-section-field>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/email-notification/email-notification-config.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;